import IBromcomProviderConfig from "../../../models/misconfig/bromcom/BromcomProviderConfig";
import React, {useState, useEffect} from "react";
import { Col, Row } from "react-bootstrap";
import IConfigJson from "../../../models/misconfig/ConfigJson";
import BiometricFilterView from "../biometric-filter-view";

const defaultAttendanceApplicationVersion = 1;

export default function BromcomProviderConfigView(props: IConfigJson) {
    const [BromcomConfig, setBromcomConfig] = useState<IBromcomProviderConfig | null>(null);
    const attendanceEnabled = BromcomConfig?.Attendance?.Enabled === true;
    const attendanceApplicationVersion = BromcomConfig?.Attendance?.AttendanceApplicationVersion
        ?? defaultAttendanceApplicationVersion;
    const attendanceWritebackLiveDate = BromcomConfig?.Attendance?.LiveDate;

    useEffect(() => {
        if (props.configJson) {
            const configObj: IBromcomProviderConfig = JSON.parse(props.configJson);
            setBromcomConfig(configObj);
        }
    }, [props.configJson]);

    return (
        <div className="bromcom-provider-config-view">
            <section className="bromcom-provider-config-section" aria-labelledby="bromcom-view-general-config-heading">
                <h3 id="bromcom-view-general-config-heading">General Config</h3>
                <Row>
                    <Col md={4} className="pb-2"><b>MIS Type</b></Col>
                    <Col md={8}>Bromcom</Col>
                </Row>
                <Row>
                    <Col md={4} className="pb-2"><b>School ID</b></Col>
                    <Col md={8}>{BromcomConfig?.SchoolID}</Col>
                </Row>
                <Row>
                    <Col md={4} className="pb-2"><b>Application Version</b></Col>
                    <Col md={8}>{BromcomConfig?.ApplicationVersion}</Col>
                </Row>
            </section>
            <section className="bromcom-provider-config-section" aria-labelledby="bromcom-view-mis-read-data-heading">
                <h3 id="bromcom-view-mis-read-data-heading">MIS Read Data</h3>
                <BiometricFilterView filter={BromcomConfig?.BiometricConsents}/>
                <Row>
                    <Col md={12} className="pb-2"><span className="misconfig-filter-subheading">Medical conditions filters</span></Col>
                </Row>
                 <Row>
                    <Col md={4} className="pb-2 ps-4"><b>Dietary needs</b></Col>
                    <Col md={8}>{BromcomConfig?.MedicalConditionsFilter?.DietaryNeeds.join(", ")}</Col>
                </Row>
                <Row>
                    <Col md={4} className="pb-2 ps-4"><b>Dietary preferences</b></Col>
                    <Col md={8}>{BromcomConfig?.MedicalConditionsFilter?.DietaryPreferences.join(", ")}</Col>
                </Row>
            </section>
            <section className="bromcom-provider-config-section" aria-labelledby="bromcom-view-attendance-heading">
                <h3 id="bromcom-view-attendance-heading">Attendance Config</h3>
                <Row>
                    <Col md={4} className="pb-2"><b>Attendance</b></Col>
                    <Col md={8}>{attendanceEnabled ? "Enabled" : "Disabled"}</Col>
                </Row>
                {attendanceEnabled && (
                    <>
                        <Row>
                            <Col md={4} className="pb-2"><b>Attendance application version</b></Col>
                            <Col md={8}>{attendanceApplicationVersion}</Col>
                        </Row>
                        <Row>
                            <Col md={4} className="pb-2"><b>Writeback live date</b></Col>
                            <Col md={8}>{attendanceWritebackLiveDate ?? "Not configured"}</Col>
                        </Row>
                    </>
                )}
            </section>
        </div>
    );    
}